// List of components also used in the AngularJS side
import './layout.component';
import './summary-bar.component';